export default "__VITE_ASSET__BmUOw97g__"